import { AuditLogChangeType, ResourceType } from "@common/types/auditLog";
import { HistoryTransactionDetailsRow } from "./views/historyTransactionDetailsViewConfig";

const ACCRUAL_RESOURCE_TYPES: readonly ResourceType[] = [
    ResourceType.BILL,
    ResourceType.INVOICE,
];

export const isRowDeletedAccrual = (row: HistoryTransactionDetailsRow) =>
    ACCRUAL_RESOURCE_TYPES.includes(row.resourceType) &&
    row.changeType === AuditLogChangeType.DELETE;

export const isRowDeleted = (row: HistoryTransactionDetailsRow) =>
    row.changeType === AuditLogChangeType.DELETE;

export const isTransactionRow = (row: HistoryTransactionDetailsRow) =>
    row.resourceType === ResourceType.TRANSACTION;
